import { render } from "./HomeLatestNotice.vue?vue&type=template&id=6e7534d4&ts=true"
import script from "./HomeLatestNotice.vue?vue&type=script&lang=ts"
export * from "./HomeLatestNotice.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__